import './imageBlock.scss';

import { GatsbyImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

export default function ImageBlock(props: {
    subtitle: string;
    title: string;
    content: string;
    image: IGatsbyImageData;
    children?: any;
}) {
    const { content, image, subtitle, title, children } = props;
    return (
        <div className='drolet-image-block-container'>
            <div className='drolet-block-content'>
                {image ? (
                    <GatsbyImage
                        className='drolet-block-image'
                        image={image}
                        alt=''
                    />
                ) : (
                    <div className='drolet-block-image'></div>
                )}
                <div className='drolet-block'>
                    <div className='drolet-block-blackbg'>
                        <div className='drolet-block-title-div'>
                            <span className='drolet-block-subtitle'>
                                {subtitle || ''}
                            </span>
                            <span className='drolet-block-title'>
                                {title || ''}
                            </span>
                        </div>
                    </div>
                    <div className='drolet-block-text'>
                        <span className='content-text'>{content || ''}</span>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
